import { Component, OnInit, OnDestroy, PLATFORM_ID, Inject, output, EventEmitter, Output, ChangeDetectorRef, ChangeDetectionStrategy, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ClientService } from '../../services/client-service';
import { firstValueFrom } from 'rxjs';
import { ActiveTripData, ActiveTripDialogComponent } from '../active-trip-dialog/active-trip-dialog.component';
import { TripFlowDialogComponent } from '../trip-flow-dialog/trip-flow-dialog.component';
import { MatDialog } from '@angular/material/dialog';

interface TripResponse {
  success: boolean;
  message: string;
  activeTrip: boolean;
  activeTripId: string;
  ticket: {
    tripType: number;
    tripMode: number;
    initialAddress: string;
    destinationAddress: string;
    fare: number;
    status: number;
    driverId: string;
    driverFullName: string;
    driverPhoneNumber: string;
    driverPhoneCountry: string;
    driverCarModel: string;
    driverCarPlateNumber: string;
    taxiNum: number;
    scheduledDatetime: string;
    tripRequestTime: string;
    ref: string;
    ticketId: string;
    passengers_nb: number;
    luggage_nb: number;
  };
}

@Component({
  selector: 'app-trip-notification',
  templateUrl: './trip-notification.component.html',
  styleUrls: ['./trip-notification.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  
  imports: [CommonModule, RouterModule, TranslateModule]
})
export class TripNotificationComponent implements OnInit, OnDestroy {
  activeTrip: TripResponse | null = null;
  private refreshInterval: any;
  @Output() notifyDriver: EventEmitter<{ ticketId: string, isHasDriver: boolean,ticket: any }> = new EventEmitter<{ ticketId: string, isHasDriver: boolean,ticket: any }>();

  
  @Input()
  isShowActiveTripDialog: boolean = true;

  /** Si false, pas de modale « trajet actif » (même logique que le trip-flow sur la landing). */
  @Input()
  allowActiveTripPromptByUrl = false;

  constructor(
    private clientService: ClientService,
        private _changeDetectorRef: ChangeDetectorRef,
        private dialog: MatDialog,
    
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {}

  ngOnInit(): void {
    
    // if (this.platformId) {
      // Check immediately
      this.checkActiveTrip();

      
    // }
  }

  ngOnDestroy(): void {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
  }

  private closeTripFlowDialogIfOpen(): void {
    for (const ref of this.dialog.openDialogs) {
      if (ref.componentInstance instanceof TripFlowDialogComponent) {
        ref.close();
      }
    }
  }

  private checkActiveTrip(): void {
    this.clientService.getActiveTrip().subscribe({
      next:async (trip: TripResponse) => {
        console.log('Active trip response:', trip);
        if (trip && trip.success && trip.activeTrip) {
          // alert('You have an active trip!');
          this.activeTrip = trip;
          if (
            this.activeTrip.ticket.tripType === 3 &&
            this.isShowActiveTripDialog &&
            this.allowActiveTripPromptByUrl
          ) {
            await this.showActiveTripDialog();
          }
         
          this._changeDetectorRef.markForCheck();
        } else {
          this.activeTrip = null;
        }
      },
      error: (error) => {
        console.error('Error fetching active trip:', error);
        this.activeTrip = null;
      }
    });
  }

  
  /**
   * Show active trip dialog if trip exists
   */
  
  async  showActiveTripDialog(): Promise<void> {
    try {
      this.closeTripFlowDialogIfOpen();
      this.isShowActiveTripDialog=false;
      // let res = await firstValueFrom(this.clientService.getActiveTrip());
      // console.log('Active trip data:', res);
      
      // if (res?.success && res?.ticket) {
      // alert('Displaying active trip dialog');
        // const tripData: ActiveTripData = {
        //   scheduledTime: this.activeTrip?.ticket.scheduledDatetime,
        //   initialAddress: this.activeTrip?.ticket.initialAddress ?? '',
        //   destinationAddress: this.activeTrip?.ticket.destinationAddress ?? '',
        //   nbrPassengers: this.activeTrip?.ticket.passengers_nb || 0,
        //   nbrLuggage: this.activeTrip?.ticket.luggage_nb || 0,
         
        // };

        const dialogRef = this.dialog.open(ActiveTripDialogComponent, {
          data: this.activeTrip,
          disableClose: true,
          panelClass: 'active-trip-dialog'
        });
        console.log('Active trip dialog opened with data:', this.activeTrip);

        dialogRef.afterClosed().subscribe(async (result) => {
          console.log('Active trip dialog result:', result);
          
          if (result === 'keep_searching') {
            // Continue with the current trip - load drivers list
            // this.listDriversAccepted = res.drivers || [];
            // this.searchTimeRemaining = res.total_max_duration / 1000;
            // this.showListDrivers = true;
          this.notifyDriver.emit({ticketId: this.activeTrip?.ticket.ticketId?? '',isHasDriver:this.isHasDriver(),ticket: this.activeTrip?.ticket });
          this._changeDetectorRef.markForCheck();       
          } else if (result === 'cancel') {
            // Cancel the trip
            try {
             let res=  await firstValueFrom(this.clientService.cancelTrip(this.activeTrip?.ticket.ticketId || ''));

              if(res.success){
                this.activeTrip = null;
                this._changeDetectorRef.markForCheck();
                // this.openDialog('Success', 'Trip cancelled successfully', 'heroicons_outline:check-circle');
              }

            } catch (err) {
            //   console.error('Error cancelling trip:', err);
            //   this.openDialog('Error', 'Failed to cancel trip', 'heroicons_outline:exclamation');
            }
          }
        });
      // }
    } catch (err) {
      console.log('Error fetching active trip:', err);
    }
  }

  isScheduledTrip(): boolean {
    if (!this.activeTrip?.ticket) return false;
    const now = new Date();
    const scheduledTime = new Date(this.activeTrip.ticket.scheduledDatetime);
    return scheduledTime.getTime() > now.getTime();
  }



  isNowTrip(): boolean {
    if (!this.activeTrip?.ticket) return false;

    const now = new Date();
    const tripRequestTime = new Date(this.activeTrip.ticket.tripRequestTime);
    const scheduledTime = this.activeTrip.ticket.scheduledDatetime 
      ? new Date(this.activeTrip.ticket.scheduledDatetime)
      : null;

    if (scheduledTime) {
      const timeDiff = scheduledTime.getTime() - now.getTime();
      const thirtyMinutesInMs = 30 * 60 * 1000;
      return timeDiff <= thirtyMinutesInMs && timeDiff >= -thirtyMinutesInMs;
    }

    const oneHourInMs = 60 * 60 * 1000;
    return (now.getTime() - tripRequestTime.getTime()) <= oneHourInMs;
  }

  getTimeMessage(): string {
    if (!this.activeTrip?.ticket) return '';

    const scheduledTime = this.activeTrip.ticket.scheduledDatetime 
      ? new Date(this.activeTrip.ticket.scheduledDatetime)
      : null;

    if (scheduledTime) {
      const timeStr = scheduledTime.toLocaleTimeString('fr-FR', { 
        hour: '2-digit', 
        minute: '2-digit' 
      });
      const dateStr = scheduledTime.toLocaleDateString('fr-FR', {
        day: '2-digit',
        month: '2-digit'
      });
      return `${timeStr} le ${dateStr}`;
    }
    return '';
  }

  dismiss(): void {

  }
  isHasDriver(): boolean {
    return this.activeTrip?.ticket?.driverId ? true : false;
  }

  returnToNotifyDriver(): void {

    this.notifyDriver.emit({ticketId: this.activeTrip?.ticket.ticketId?? '',isHasDriver:this.isHasDriver(),ticket: this.activeTrip?.ticket });

  }
}
